module.exports = __webpack_public_path__ + "static/media/fsc2.6252991f.png";